import { render } from "./Swlang.vue?vue&type=template&id=1572fde7&scoped=true"
import script from "./Swlang.vue?vue&type=script&lang=js"
export * from "./Swlang.vue?vue&type=script&lang=js"

import "./Swlang.vue?vue&type=style&index=0&id=1572fde7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1572fde7"]])

export default __exports__